import React from 'react';
import { TagIcon, AwardIcon, AlertTriangle } from 'lucide-react';
export function DiscountBanner({
  discountSelections,
  onDiscountToggle,
  isGen2Mode = false
}) {
  return <div className={`border-2 rounded-lg p-6 mb-8 shadow-sm transition-all ${isGen2Mode ? 'bg-slate-50 border-slate-300 opacity-60' : 'bg-gradient-to-r from-green-50 to-emerald-50 border-green-200'}`} data-id="element-535">
      <div className="flex items-start mb-4" data-id="element-536">
        <TagIcon size={24} className={`mr-3 flex-shrink-0 mt-1 ${isGen2Mode ? 'text-slate-400' : 'text-green-600'}`} data-id="element-537" />
        <div data-id="element-538">
          <h3 className={`text-lg font-semibold mb-1 ${isGen2Mode ? 'text-slate-500' : 'text-green-800'}`} data-id="element-539">
            Available Discount
          </h3>
          <p className={`text-sm ${isGen2Mode ? 'text-slate-500' : 'text-green-700'}`} data-id="element-540">
            {isGen2Mode ? 'Discounts are not available for Gen 2 equipment rentals.' : 'Select if applicable. This will be reviewed and applied by our team.'}
          </p>
        </div>
      </div>

      {isGen2Mode && <div className="mb-4 p-3 bg-orange-50 border border-orange-300 rounded-lg" data-id="element-541">
          <div className="flex items-center gap-2" data-id="element-542">
            <AlertTriangle size={16} className="text-orange-600 flex-shrink-0" data-id="element-543" />
            <p className="text-xs text-orange-800 font-medium" data-id="element-544">
              Gen 2 equipment is not eligible for USAT discounts. Switch to Gen
              3 to access discounts.
            </p>
          </div>
        </div>}

      <div className="space-y-3" data-id="element-545">
        {/* USAT Sanctioned Event Discount */}
        <div className={`rounded-lg p-4 border-2 shadow-sm ${isGen2Mode ? 'bg-slate-100 border-slate-300' : 'bg-white border-green-300'}`} data-id="element-546">
          <div className="flex items-start" data-id="element-547">
            <div className="flex items-center h-5" data-id="element-548">
              <input id="usatSanctioned" type="checkbox" checked={discountSelections.usatSanctioned} onChange={() => onDiscountToggle('usatSanctioned')} disabled={isGen2Mode} className={`h-5 w-5 rounded ${isGen2Mode ? 'border-slate-300 text-slate-400 cursor-not-allowed' : 'border-green-300 text-green-600 focus:ring-green-500'}`} data-id="element-549" />
            </div>
            <div className="ml-3 flex-1" data-id="element-550">
              <label htmlFor="usatSanctioned" className={`font-semibold flex items-center ${isGen2Mode ? 'text-slate-400 cursor-not-allowed' : 'text-green-800 cursor-pointer'}`} data-id="element-551">
                <AwardIcon size={18} className={`mr-2 ${isGen2Mode ? 'text-slate-400' : 'text-green-600'}`} data-id="element-552" />
                USAT Sanctioned Event
                <span className={`ml-2 text-xs font-bold px-2.5 py-1 rounded-full ${isGen2Mode ? 'bg-slate-300 text-slate-500' : 'bg-green-600 text-white'}`} data-id="element-553">
                  15% OFF
                </span>
              </label>
              <p className={`text-sm mt-1 ${isGen2Mode ? 'text-slate-400' : 'text-green-700'}`} data-id="element-554">
                {isGen2Mode ? 'Not available for Gen 2 equipment' : 'For officially sanctioned USA Taekwondo events. Verification required.'}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className={`mt-4 pt-4 border-t ${isGen2Mode ? 'border-slate-200' : 'border-green-200'}`} data-id="element-555">
        <p className={`text-xs flex items-center ${isGen2Mode ? 'text-slate-400' : 'text-green-700'}`} data-id="element-556">
          <TagIcon size={14} className="mr-1" data-id="element-557" />
          {isGen2Mode ? 'Switch to Gen 3 equipment to access available discounts' : 'Discount is subject to verification and approval by our team'}
        </p>
      </div>
    </div>;
}